// removed by extract-text-webpack-plugin
module.exports = {"hero":"styles__hero___281qg","title":"styles__title___2-T-1","content":"styles__content___Nwu3x","flex-row":"styles__flex-row___31B-R","description":"styles__description___3bfFQ","show-menu":"styles__show-menu___2VHXW","alignRight":"styles__alignRight___1VTM5"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Cafe/styles.scss
// module id = 441
// module chunks = 0